<div class="no-configuration-container">
  <div class="no-configuration-header">
    <div class="img-container">
      <nb-icon [icon]="containerIcon" pack="icomoon" class="icon"></nb-icon>
    </div>
    <div class="text-container">
      <p *ngIf="isAvailable && !urlConfigurationDefined">{{ 'view_translations.add_url_configuration_first' | translate }}</p>
      <p *ngIf="isAvailable && !textWithHtml && urlConfigurationDefined">{{ ( 'view_translations.' + text ) | translate }}</p>
      <p *ngIf="!isAvailable">{{ 'view_translations.function_not_available' | translate }}</p>
      <p *ngIf="isAvailable && textWithHtml && urlConfigurationDefined" [innerHTML]="'view_translations.' + text | translate"></p>
    </div>
  </div>
  <div class="config-btn" *ngIf="isAvailable && urlConfigurationDefined && buttonText">
    <app-primary-button *ngIf="buttonText" [buttonText]="buttonText" [icon]="'plus'" [iconSize]="12" [background]="'orange'" (emitAction)="addConfiguration()">
    </app-primary-button>
  </div>
</div>
